import type { OutboxItem } from '@Domain/Ports/Outbox/OutboxPort';
import resolveTransferStatus from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewUpload/TransferCard/Hooks/transferStatus/resolveTransferStatus';
import type { TransferStatus } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewUpload/TransferCard/Hooks/transferStatus/transferStatus';
import useConnectivity from '@UI/Providers/PortsProvider/Hooks/Connectivity/useConnectivity';
import * as React from 'react';

/** The status to display for a queue item, as the queue currently reports it. */
const useTransferStatus = (outboxItem: OutboxItem): TransferStatus => {
	const isOnline = useConnectivity();

	return React.useMemo(
		() => resolveTransferStatus(outboxItem, { isOnline, nowMs: Date.now() }),
		[outboxItem, isOnline],
	);
};

export default useTransferStatus;
